import * as yup from 'yup';
import { hasFahrradDiebstahlAndRequiresAmount } from '@/features/Sparten/hau/formConfigs/sharedRenderConditions';

export const hauSchema = yup.object({
  vorschaden: yup.string().default('').required(),
  tarifgruppe: yup.string().default('').required(),
  laufzeit: yup.string().default('').required(),
  zahlweise: yup.string().default('').required(),
  selbstbeteiligung: yup.string().default('').required(),
  demvRabattiert: yup.boolean().default(true),

  plz: yup.string().default('').required(),
  ort: yup.string().default('').required(),
  strasse: yup.string().default('').required(),
  hausnummer: yup.string().default('').required(),
  wohnflaeche: yup
    .number()
    .nullable()
    .default(null)
    .min(1)
    .max(500)
    .integer('Bitte die Wohnfläche nur als ganze m² angeben')
    .required(),
  gebaeudeart: yup.string().default('').required(),
  bauartklasse: yup.string().default('').required(),
  versicherungssumme: yup
    .number()
    .nullable()
    .default(null)
    .min(10000, 'Der Wert muss mindestens 10.000 € betragen.')
    .max(10000000)
    .required(),
  fahrraddiebstahl: yup.string().default('').required(),
  fahrradsumme: yup
    .number()
    .nullable()
    .default(null)
    .when({
      is: () => hasFahrradDiebstahlAndRequiresAmount(),
      then: yup.number().required(),
    }),
  glasversicherung: yup.boolean().default(false).required(),
  elementarversicherung: yup.boolean().default(false).required(),
  ceran: yup.boolean().default(false).required(),

  temporaryInputFields: yup.object({
    hasZuersError: yup.boolean().default(false),
    zuersZoneConfirmed: yup
      .boolean()
      .default(false)
      .when('hasZuersError', {
        is: (val: boolean) => val,
        then: yup.boolean().notOneOf([false]),
      }),
    updateClientAddress: yup.boolean().default(false),
    versicherungssummeHasManuallyChanged: yup.boolean().default(false),
  }),
});
